import { render, staticRenderFns } from "./Item11.vue?vue&type=template&id=615c5a3a&scoped=true&"
import script from "./Item11.vue?vue&type=script&lang=js&"
export * from "./Item11.vue?vue&type=script&lang=js&"
import style0 from "./Item11.vue?vue&type=style&index=0&id=615c5a3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615c5a3a",
  null
  
)

export default component.exports